export default __webpack_public_path__ + "static/SC_Step_1-40a934b426c87d9d1205f0468b889fb7.svg";